import { Dialog } from "@material-ui/core";
import * as React from "react";
import CloseIcon from "src/documentUpload/close.svg";
import QuiqButton from "src/shared/QuiqButton";
import {
  RuleChangeLog,
  RuleChangeLogItem
} from "src/spread/model/spread/types";
import { RuleCard } from "./RuleCard";
import "./SaveRulesModal.scss";

interface SaveRulesModalProps {
  rules: RuleChangeLog;
  isOpen: boolean;
  closeModal: () => void;
  deleteRules: () => void;
  updateRules: () => void;
  openDeleteRuleModal: (rule: RuleChangeLogItem) => void;
  completeSpread: (rulesToDelete?: RuleChangeLogItem[]) => void;
}

export class SaveRulesModal extends React.Component<SaveRulesModalProps> {
  constructor(props: SaveRulesModalProps) {
    super(props);
  }

  public componentDidMount() {
    this.props.updateRules();
  }

  public render() {
    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.props.closeModal}
        className="SaveRulesModal"
        PaperProps={{ className: "SaveRulesModal__paper" }}
        transitionDuration={0}
        disableBackdropClick={true}
      >
        <div className="SaveRulesModal__header">
          <div className="SaveRulesModal__title">Save Rules</div>
          <div
            className="SaveRulesModal__close-icon-container"
            onClick={this.handleCancelClick}
          >
            <img src={CloseIcon} className="SaveRulesModal__close-icon" />
          </div>
        </div>
        <div className="SaveRulesModal__subtitle">
          Saved mapping rules will be automatically applied the next time you
          spread this entity.
        </div>
        <div className="SaveRulesModal__outer__content">
          <div className="SaveRulesModal__content">
            {Object.keys(this.props.rules).map((key, index) => {
              const rule = this.props.rules[key];
              return (
                <RuleCard
                  rule={rule}
                  key={`${rule.nodeId}-${index}`}
                  openDeleteRuleModal={this.props.openDeleteRuleModal}
                />
              );
            })}
          </div>
          {Object.keys(this.props.rules).length < 1 && (
            <div className="SaveRulesModal__content--empty">
              There are no rules to save.
            </div>
          )}
        </div>
        <div className="SaveRulesModal__actions">
          {
            <QuiqButton
              className="SaveRulesModalForm__actions__cancel"
              variant="text"
              onClick={this.handleCancelClick}
            >
              CANCEL
            </QuiqButton>
          }

          <QuiqButton
            className="SaveRulesModal__actions__save"
            color="blue"
            onClick={this.handleSaveAndCompleteClick}
          >
            CONFIRM & PROCEED
          </QuiqButton>
        </div>
      </Dialog>
    );
  }

  private handleSaveAndCompleteClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    this.props.completeSpread();
    this.props.closeModal();
  };

  private handleCancelClick = () => {
    this.props.deleteRules();
    this.props.closeModal();
  };
}



// WEBPACK FOOTER //
// ./src/ruleView/SaveRulesModal.tsx